import Nullstack from 'nullstack';
export default function IconIceCreamOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-ice-cream-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M12 21.5v-4.5"
  }), "   ", Nullstack.element("path", {
    d: "M8 8v9h8v-1m0 -4v-5a4 4 0 0 0 -7.277 -2.294"
  }), "   ", Nullstack.element("path", {
    d: "M8 10.5l1.74 -.76m2.79 -1.222l3.47 -1.518"
  }), "   ", Nullstack.element("path", {
    d: "M8 14.5l4.488 -1.964"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}